import Cookies from "js-cookie";
import { api } from "../../boot/axios";

export default function exampleService() {
  const headers = {
    Authorization: `Bearer ${Cookies.get("jwt")}`,
  };

  const getPerguntaDiaria = async (dataSelecionada) => {
    const { data } = await api.get(
      `/portal/pergunta-diaria?data=${dataSelecionada}`,
      {
        headers,
      }
    );
    return data;
  };

  const postRespostaDiaria = async (form) => {
    const { data } = await api.post("/portal/pergunta-diaria", form, {
      headers,
    });
    return data;
  };

  return {
    getPerguntaDiaria,
    postRespostaDiaria,
  };
}
